import { fromJS } from 'immutable';
import type { AnyAction } from 'redux';

import { TypedMap } from 'utils/typed-map';

import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  SAVE_FAILED,
  REMOVE,
  REMOVE_SUCCESS,
  REMOVE_FAILED,
} from './constants';

export type DonationCreditRulesFormPageState = TypedMap<{
  loading: boolean;
}>;

export const initialState: DonationCreditRulesFormPageState = fromJS({
  loading: true,
});

function donationCreditRulesFormPageReducer(
  state = initialState,
  action: AnyAction
): DonationCreditRulesFormPageState {
  switch (action.type) {
    case INIT:
      return state.set('loading', true);

    case INIT_SUCCESS:
      return state.set('loading', false);

    case INIT_FAILED:
      return state.merge({ loading: false, errorCode: action.errorCode });

    case SAVE_FAILED:
      return state.merge({ errorCode: action.errorCode });

    case REMOVE:
      return state.set('loading', true);

    case REMOVE_SUCCESS:
      return state.set('loading', false);

    case REMOVE_FAILED:
      return state.merge({ errorCode: action.errorCode });

    default:
      return state;
  }
}

export default donationCreditRulesFormPageReducer;
